import {Model} from 'vue-mc'
import {required, string, validation} from 'vue-mc/validation'

export default class Register extends Model {
    defaults() {
        return {
            email: null,
            password: null,
        }
    }

}
